import React, { useState } from "react";

import PlusIcon from "../../assets/icons/plus.svg";
import "./appointmentProfile.scss";
import BookingWizard from "../AvailabilityTable/BookingWizard";

const ScheduleAppointmentComponent = ({ setRefetch }) => {
    const [isBookingWizardOpen, setIsBookingWizardOpen] = useState(false);

    const handleCloseWizard = () => {
        setIsBookingWizardOpen(false);
    };

    return (
        <>
            <div className="appointment-profile">
                <div className="appointment-profile-action">
                    <div className="appointment-profile-action-invite-allowed">
                        <button
                            onClick={() => setIsBookingWizardOpen(true)}
                            className="appointment-profile-invite"
                        >
                            <span>New Appointment</span>
                        </button>
                    </div>
                </div>
            </div>
            {isBookingWizardOpen && (
                <BookingWizard provider={null} onClose={handleCloseWizard} />
            )}
        </>
    );
};

export default ScheduleAppointmentComponent;
